
import Fancybox from '../../../src/js/shared/fancybox';
import analytics from '../../../src/js/shared/analytics';
import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();
$(function() {

	const banner = {

		init: function() {
			this.cacheDOM();
			this.bindEvents();
			this.bannerPopup();
			this.slideshowInit();
		},

		cacheDOM: function() {
			this.$banner = $('.banner');
			this.$ctaButton = this.$banner.find('.js-banner-cta');
			this.$slideshow = this.$banner.find('.js-banner-slideshow');
		},

		bindEvents: function() {
			this.$ctaButton.on('click', this.handleCtaClick.bind(this));
		},

		bannerPopup: function() {
			Fancybox.initializefancyboxPopup('.js-popup-trigger', '.js-popup', 'popup-custom-class');
		},

		// Markup is only rendered for 2+ gallery images; reduced-motion users keep the first image static
		slideshowInit: function() {
			if (!this.$slideshow.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				return;
			}

			sliders.initializeSlider('.js-banner-slideshow', {
				slidesToShow: 1,
				fade: true,
				speed: 1200,
				autoplaySpeed: 5000,
				cssEase: 'ease-in-out',
				pauseOnHover: false,
				pauseOnFocus: false,
				accessibility: false,
				draggable: false,
				swipe: false,
				touchMove: false,
				responsive: [],
			});
		},

		handleCtaClick: function() {
			/* eslint-disable camelcase -- param names must match the registered GA4 event dimensions */
			analytics.trackEvent('booking_cta_click', {
				cta_location: this.$banner.data('cta-location') || '',
			});
			/* eslint-enable camelcase */
		},

	};

	banner.init();
});
